import * as models from "./models";

const PropTypeModels = {
    ...models,
};
export default PropTypeModels;
